import { Button, Col, ErrorContent, Row, Table } from '@/components';
import { PAGE_SIZE_IN_BACKEND } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useGroups } from '../_hooks/group';
import { useGroupListSearchQueryStates } from '../_hooks/search-query-states';
import { GroupSearchForm } from './GroupSearchForm';

export const ProjectGroupList: FC = () => {
  const { t } = useTranslation();
  const { searchQueryStates, setSearchQueryStates } =
    useGroupListSearchQueryStates();
  const groups = useGroups({
    name: searchQueryStates.name ?? undefined,
    fiscalYear: searchQueryStates.fiscalYear
      ? Number(searchQueryStates.fiscalYear)
      : undefined,
    targetType: 'project',
  });
  const navigate = useNavigate();

  return (
    <Row>
      <Col span={24}>
        <GroupSearchForm />
      </Col>
      <Col span={24}>
        {groups.isError ? (
          <ErrorContent reloadable={false} />
        ) : (
          <Table
            rowKey="id"
            loading={groups.isLoading}
            dataSource={groups.data?.results}
            columns={[
              { title: t('name'), key: 'name', dataIndex: 'name' },
              {
                title: t('fiscal-year'),
                key: 'fiscalYear',
                dataIndex: 'fiscalYear',
              },
              {
                title: t('organization'),
                key: 'organization',
                render: (_, record) => record.organization.name,
              },
              {
                title: '',
                key: 'buttons',
                width: 65,
                render: (_, record) => (
                  <Button
                    onClick={() => {
                      navigate(`/rs/project/group/${record.id}`);
                    }}
                  >
                    {t('details')}
                  </Button>
                ),
              },
            ]}
            pagination={{
              current: searchQueryStates.page,
              total: groups.data?.count,
              showSizeChanger: false,
              pageSize: PAGE_SIZE_IN_BACKEND,
            }}
            onChange={(pagination) => {
              if (pagination.current) {
                setSearchQueryStates((v) => ({
                  ...v,
                  page: pagination.current,
                }));
              }
            }}
          />
        )}
      </Col>
      <Col span={24} />
    </Row>
  );
};
